import deleteOutlookFavoriteService from '../services/v2/deleteOutlookFavoriteService';
import getFavoriteDataFromFavoriteId from '../selectors/v2/getFavoriteDataFromFavoriteId';
import getFavoriteIdFromCategoryId from '../selectors/v2/getFavoriteIdFromCategoryId';
import removeFavoriteCategoryV2 from '../actions/v2/removeFavoriteCategoryV2';
import {
    removeFavoriteFromStore,
    removeFavoriteCompleted,
    removeFavoriteFailed,
} from '../actions/v2/removeFavoriteActions';
import { FolderForestNodeType } from 'owa-favorites-types';
import { isCategoryInFavorites } from '../selectors/isInFavorites';
import { orchestrator } from 'satcheljs';
import isGuid from '../utils/isGuid';
import { logUsage } from 'owa-analytics-actions';
import isOutlookFavoritingInProgress from '../selectors/v2/isOutlookFavoritingInProgress';

/**
 * Remove a favorite category from the favorite store
 * @param id of the category
 * @param actionSource where the remove favorite category comes from
 */
export default orchestrator(removeFavoriteCategoryV2, async actionMessage => {
    const { categoryId } = actionMessage;
    let favoriteData;
    try {
        // Check if category is actually in favorites
        if (!isCategoryInFavorites(categoryId)) {
            // This function should not be called when trying to remove a category which is not a favorite. Do nothing
            return;
        }
        const favoriteId = getFavoriteIdFromCategoryId(categoryId);

        // Check wheter we are trying to remove a temp id due to double clicks. This should be a no-op.
        if (isGuid(favoriteId)) {
            logUsage('RemoveOutlookFavoriteCategory: attempting to remove guid', {
                guid: favoriteId,
            });
            return;
        }

        if (isOutlookFavoritingInProgress(categoryId)) {
            // No-op
            return;
        }

        favoriteData = getFavoriteDataFromFavoriteId(favoriteId, FolderForestNodeType.Category);

        // Remove from favorite from the store
        removeFavoriteFromStore(favoriteData);

        // Use Favorite Roaming API to remove an outlook favorite
        await deleteOutlookFavoriteService(favoriteId);

        removeFavoriteCompleted(favoriteData);
    } catch (error) {
        removeFavoriteFailed(error, favoriteData);
    }
});
